export default __webpack_public_path__ + "static/media/video-thumbnail-new.cd691401.svg";